import { render, staticRenderFns } from "./ChatVoiceV2.vue?vue&type=template&id=383ede23&scoped=true"
import script from "./ChatVoiceV2.vue?vue&type=script&lang=js"
export * from "./ChatVoiceV2.vue?vue&type=script&lang=js"
import style0 from "./ChatVoiceV2.vue?vue&type=style&index=0&id=383ede23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383ede23",
  null
  
)

export default component.exports